import React from 'react';
import styled from 'styled-components';
import backButton from 'images/icons/contentBackButton.svg';

const StyledBackButton = styled.div`
  position: absolute;
  z-index: 2;
  top: 30px;
  color: #9FBDD6;
  font-size: 12px;
  line-height: 17px;
  left: 36px;
  padding-left: 20px;
  background: url('${backButton}') 0px 3px no-repeat;

  &:hover {
    cursor: pointer;
  }
`;

const ContentBackButton = ({ history }) => <StyledBackButton onClick={() => history.goBack()}>Back</StyledBackButton>;

export default ContentBackButton;
